import { useSearchParams } from 'react-router';

/** List state (filters, page, sort) kept in the URL so refresh/back keep it. */
export function useListParams<K extends string>(keys: readonly K[], defaultSort: string) {
  const [params, setParams] = useSearchParams();
  const filters = Object.fromEntries(keys.map((k) => [k, params.get(k) ?? ''])) as Record<K, string>;
  const page = Math.max(0, Number(params.get('page') ?? 0) || 0);
  const sort = params.get('sort') ?? defaultSort;
  type Changes = Partial<Record<K | 'page' | 'sort', string | number | null>>;
  const update = (changes: Changes) => {
    const next = new URLSearchParams(params);
    for (const [k, v] of Object.entries(changes)) {
      if (v === null || v === undefined || v === '') next.delete(k);
      else next.set(k, String(v));
    }
    setParams(next, { replace: false, preventScrollReset: true });
  };
  const sortState = (() => {
    const [key, direction] = sort.split(',');
    return { key: key ?? '', direction: (direction === 'desc' ? 'desc' : 'asc') as 'asc' | 'desc' };
  })();
  const toggleSort = (key: string) => {
    const direction = sortState.key === key && sortState.direction === 'asc' ? 'desc' : 'asc';
    update({ sort: `${key},${direction}`, page: null } as Changes);
    return direction;
  };
  return { filters, page, sort, sortState, update, toggleSort };
}
